import React from 'react';
import PropTypes from 'prop-types';
import {Panel} from 'react-bootstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class Job extends React.Component {
  render() {
    const {job : job_container, pipeline} = this.props;
    const {selected,job} = job_container;
    const previewing = job._id == this.props.previewing_job;
    if(!job) {
      return <noscript />
    }

    const style_mode = !pipeline ? 'secondary' : job.milestone == pipeline.stages[pipeline.stages.length - 1].name ? 'success' : job.milestone == 'Cancelled' ? 'danger' : job.status == 'Lead' ? 'secondary' : 'primary';
    return <div onClick={e => this.props.onClick(this.props.job)} className="job">
      <div className={`panel ${!previewing ? `panel-featured-left panel-featured-${style_mode}` : ''}`}>
        <div className={`panel-body${previewing ? ` bg-${style_mode} animated pulse` : ''}`}>
          <div className={`widget-summary widget-summary-sm`}>
            <div className="widget-summary-col">
                <h3 className="title">{`${job.client ? job.client.name : ''}`}</h3>
                <hr className="dotted short" />
                <ul className="list-unstyled">
                <li>
                  {job.client && job.client.address ? <span>{`${job.client.address.street}, ${job.client.address.state} ${job.client.address.zip}`}<br /></span> : ''}
                  {job.client && job.client.phone || ''}
                </li>
                <li>
                  <strong className="amount"><i className="fa fa-tags"></i> {job.category} </strong>{job.work_type ? `- ${ job.work_type }` : ``}
                </li>
                <li><strong className="amount">{job.price ? <span><i className="fa fa-money"></i> {`$${Number(job.price).toLocaleString()}`}</span>: ''}</strong></li>
                </ul>
            </div>
            <div className="widget-summary-col widget-summary-col-icon">
              <div className={`summary-icon bg-${style_mode}`}><i className={`fa fa-${job.milestone == 'Closed' ? 'check' : job.milestone == 'Cancelled' ? 'times-circle' : job.status == 'Lead' ? 'address-card-o' : 'handshake-o' }`}></i></div>
              <ul className="list-unstyled list">
                <li>
                  <strong>In Status<br /></strong>
                  {moment(job.status_timestamp || Date.now()).fromNow(true)}
                </li>
                <li>
                  <strong>Last Touched<br /></strong>
                  {moment(job.updated_timestamp || Date.now()).fromNow()}
                </li>
              </ul>
            </div>
          </div>
          {(() => {
            let {user, children} = this.props.users;
            let {assigned_to} = this.props.job.job;

            if(this.props.hasPermission('/Opportunities/View Sub Users/') && children && children.length > 0) {
              let assigned_user;

              if(assigned_to._id == user._id) {
                assigned_user = user;
              }
              else {
                let assigned_child = children.find(c => c.user._id == this.props.job.job.assigned_to._id)
                if(assigned_child) {
                  assigned_user = assigned_child.user;
                }
              }

              if(assigned_user) {
                return (
                  <div>
                    <h4>Assigned To :</h4>
                    <div className='row'>
                      {(() => {
                        if(assigned_user.avatar) {
                          return (
                            <div className='col-xs-3'>
                              <img src={assigned_user.avatar} style={{width : '115%'}}/>
                            </div>
                          )
                        }
                      })()}
                      <div className='col-xs-9'>
                        <h5>{`${assigned_user.name.first} ${assigned_user.name.last}`}</h5>
                        <h5>{assigned_user.email}</h5>
                      </div>
                    </div>
                  </div>
                )
              }
            }
          })()}
        </div>
      </div>
    </div>
  }
}

Job.propTypes = {
  onClick : PropTypes.func
}

const mapStateToProps = ({jobs, pipeline, users}) => ({...jobs, pipeline: pipeline.pipeline, users});

export default connect(mapStateToProps,Actions)(Job);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job.js